"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.READABLE_TRANSACTION_TYPE = exports.TransactionType = exports.TransactionStatus = void 0;
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["Prepared"] = "PREPARED";
    TransactionStatus["Pending"] = "PENDING";
    TransactionStatus["Success"] = "SUCCESS";
    TransactionStatus["Failed"] = "FAILED";
})(TransactionStatus || (exports.TransactionStatus = TransactionStatus = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["Mint"] = "MINT";
    TransactionType["MintERC20"] = "MINT_ERC20";
    TransactionType["MintERC721"] = "MINT_ERC721";
    TransactionType["TransferERC20"] = "TRANSFER_ERC20";
    TransactionType["TransferERC721"] = "TRANSFER_ERC721";
    TransactionType["MintFungible"] = "MINT_FUNGIBLE";
    TransactionType["MintNonFungible"] = "MINT_NON_FUNGIBLE";
    TransactionType["TransferFungible"] = "TRANSFER_FUNGIBLE";
    TransactionType["TransferNonFungible"] = "TRANSFER_NON_FUNGIBLE";
    TransactionType["GrantKYC"] = "GRANT_KYC";
    TransactionType["RevokeKYC"] = "REVOKE_KYC";
    TransactionType["Pause"] = "PAUSE";
    TransactionType["Unpause"] = "UNPAUSE";
    TransactionType["Wipe"] = "WIPE";
    TransactionType["Burn"] = "BURN";
    TransactionType["Send"] = "SEND";
    TransactionType["DeployImplementation"] = "DEPLOY_IMPLEMENTATION";
    TransactionType["DeployProxy"] = "DEPLOY_PROXY";
    TransactionType["Upgrade"] = "UPGRADE";
    TransactionType["AddToBlacklist"] = "ADD_TO_BLACKLIST";
    TransactionType["RemoveFromBlacklist"] = "REMOVE_FROM_BLACKLIST";
    TransactionType["SetKYCableStatus"] = "SET_KYCABLE_STATUS";
    TransactionType["SetBlacklistableStatus"] = "SET_BLACKLISTABLE_STATUS";
    TransactionType["ChangeOwner"] = "CHANGE_OWNER";
    TransactionType["TransferToken"] = "TRANSFER_TOKEN";
    TransactionType["TransferOut"] = "TRANSFER_OUT";
    TransactionType["UpdateDocumentHashes"] = "UPDATE_DOCUMENT_HASHES";
    // Pool tokens
    TransactionType["RegisterToken"] = "REGISTER_TOKEN";
    TransactionType["UnregisterToken"] = "UNREGISTER_TOKEN";
    // XRPL / Stellar specific
    TransactionType["ReserveTrustLine"] = "RESERVE_TRUST_LINE";
    TransactionType["ApproveTrustLine"] = "APPROVE_TRUST_LINE";
    TransactionType["TreasuryTrustLine"] = "TREASURY_TRUST_LINE";
    TransactionType["TokenPayment"] = "TOKEN_PAYMENT";
    TransactionType["MintToTreasury"] = "MINT_TO_TREASURY";
    // Hedera specific
    TransactionType["AssociateToken"] = "ASSOCIATE_TOKEN";
    TransactionType["CreateToken"] = "CREATE_TOKEN";
    TransactionType["CreateProxyFile"] = "CREATE_PROXY_FILE";
    TransactionType["AppendProxyFile"] = "APPEND_PROXY_FILE";
    TransactionType["CreateImplementationFile"] = "CREATE_IMPLEMENTATION_FILE";
    TransactionType["AppendImplementationFile"] = "APPEND_IMPLEMENTATION_FILE";
    TransactionType["CreateProxyContract"] = "CREATE_PROXY_CONTRACT";
    TransactionType["CreateImplementationContract"] = "CREATE_IMPLEMENTATION_CONTRACT";
    TransactionType["PayoutContractImplementationCreateFile"] = "PAYOUT_CONTRACT_IMPLEMENTATION_CREATE_FILE";
    TransactionType["PayoutContractProxyCreateFile"] = "PAYOUT_CONTRACT_PROXY_CREATE_FILE";
    TransactionType["PayoutContractImplementationAppendFile"] = "PAYOUT_CONTRACT_IMPLEMENTATION_APPEND_FILE";
    TransactionType["PayoutContractProxyAppendFile"] = "PAYOUT_CONTRACT_PROXY_APPEND_FILE";
    TransactionType["PayoutContractImplementationDeployFile"] = "PAYOUT_CONTRACT_IMPLEMENTATION_DEPLOY_FILE";
    TransactionType["PayoutContractProxyDeployFile"] = "PAYOUT_CONTRACT_PROXY_DEPLOY_FILE";
    TransactionType["PayoutContractPause"] = "PAYOUT_CONTRACT_PAUSE";
    TransactionType["PayoutContractUnpause"] = "PAYOUT_CONTRACT_UNPAUSE";
    TransactionType["PayoutContractGrantKyc"] = "PAYOUT_CONTRACT_GRANT_KYC";
    TransactionType["PayoutContractRevokeKyc"] = "PAYOUT_CONTRACT_REVOKE_KYC";
    TransactionType["PayoutContractSetPayoutPerIndex"] = "PAYOUT_CONTRACT_SET_PAYOUT_PER_INDEX";
    TransactionType["PayoutContractSetEligibilityToken"] = "PAYOUT_CONTRACT_SET_ELIGIBILITY_TOKEN";
    TransactionType["PayoutContractSetPayoutToken"] = "PAYOUT_CONTRACT_SET_PAYOUT_TOKEN";
    TransactionType["PayoutContractPayoutBatch"] = "PAYOUT_CONTRACT_PAYOUT_BATCH";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
exports.READABLE_TRANSACTION_TYPE = {
    [TransactionType.Mint]: 'Mint',
    [TransactionType.MintERC20]: 'Mint ERC20',
    [TransactionType.MintERC721]: 'Mint ERC721',
    [TransactionType.TransferERC20]: 'Transfer ERC20',
    [TransactionType.TransferERC721]: 'Transfer ERC721',
    [TransactionType.MintFungible]: 'Mint Fungible',
    [TransactionType.MintNonFungible]: 'Mint Non-Fungible',
    [TransactionType.TransferFungible]: 'Transfer Fungible',
    [TransactionType.TransferNonFungible]: 'Transfer Non-Fungible',
    [TransactionType.GrantKYC]: 'Grant KYC',
    [TransactionType.RevokeKYC]: 'Revoke KYC',
    [TransactionType.Wipe]: 'Wipe',
    [TransactionType.Burn]: 'Burn',
    [TransactionType.Pause]: 'Pause',
    [TransactionType.Unpause]: 'Unpause',
    [TransactionType.Send]: 'Send',
    [TransactionType.DeployImplementation]: 'Deploy implementation contract',
    [TransactionType.DeployProxy]: 'Deploy proxy contract',
    [TransactionType.Upgrade]: 'Upgrade contract',
    [TransactionType.AddToBlacklist]: 'Add to blacklist',
    [TransactionType.RemoveFromBlacklist]: 'Remove from blacklist',
    [TransactionType.SetKYCableStatus]: 'Set KYCable status',
    [TransactionType.SetBlacklistableStatus]: 'Set blacklistable status',
    [TransactionType.ChangeOwner]: 'Change owner',
    [TransactionType.TransferToken]: 'Transfer token',
    [TransactionType.TransferOut]: 'Transfer out',
    [TransactionType.UpdateDocumentHashes]: 'Update document hashes',
    // Pool tokens
    [TransactionType.RegisterToken]: 'Register token',
    [TransactionType.UnregisterToken]: 'Unregister token',
    // XRPL / Stellar specific
    [TransactionType.ReserveTrustLine]: 'Create trust line for reserve',
    [TransactionType.TreasuryTrustLine]: 'Create trust line for treasury',
    [TransactionType.ApproveTrustLine]: 'Approve trust line',
    [TransactionType.TokenPayment]: 'Token payment',
    [TransactionType.MintToTreasury]: 'Mint to treasury',
    // Hedera specific
    [TransactionType.AssociateToken]: 'Associate token',
    [TransactionType.CreateToken]: 'Create token',
    [TransactionType.CreateProxyFile]: 'Create proxy file',
    [TransactionType.AppendProxyFile]: 'Append proxy file',
    [TransactionType.CreateImplementationFile]: 'Create implementation file',
    [TransactionType.AppendImplementationFile]: 'Append implementation file',
    [TransactionType.CreateProxyContract]: 'Create proxy contract',
    [TransactionType.CreateImplementationContract]: 'Create implementation contract',
    [TransactionType.PayoutContractImplementationCreateFile]: 'Create payout contract implementation file',
    [TransactionType.PayoutContractProxyCreateFile]: 'Create payout contract proxy file',
    [TransactionType.PayoutContractImplementationAppendFile]: 'Append payout contract implementation file',
    [TransactionType.PayoutContractProxyAppendFile]: 'Append payout contract proxy file',
    [TransactionType.PayoutContractImplementationDeployFile]: 'Deploy payout contract implementation file',
    [TransactionType.PayoutContractProxyDeployFile]: 'Deploy payout contract proxy file',
    [TransactionType.PayoutContractPause]: 'Pause payout contract file',
    [TransactionType.PayoutContractUnpause]: 'Unpause payout contract file',
    [TransactionType.PayoutContractGrantKyc]: 'Payout Contract Grant Kyc',
    [TransactionType.PayoutContractRevokeKyc]: 'Payout Contract Revoke Kyc',
    [TransactionType.PayoutContractSetPayoutPerIndex]: 'Payout Contract set payout per index',
    [TransactionType.PayoutContractSetEligibilityToken]: 'Payout Contract set eligibility token',
    [TransactionType.PayoutContractSetPayoutToken]: 'Payout Contract set payout token',
    [TransactionType.PayoutContractPayoutBatch]: 'Payout batch',
};
